module.exports = __webpack_public_path__ + "assets/5-Austin-Technology-Sales-Positions.c57d733c.png";